// supported role in this application so far
export default {
  TEACHER: "TEACHER",
  STUDENT: "STUDENT",
  SCHOOL_ADMIN: "SCHOOL ADMIN",
  CONTENT_APPROVER: "CONTENT APPROVER",
  CONTENT_OFFICER: "CONTENT OFFICER",
  HELPDESK_ADMIN: "HELPDESK ADMIN",
  ALP_ADMIN: "ALP ADMIN",
  VLE_ADMIN: "VLE ADMIN",
  CCPM_ADMIN: "CCPM ADMIN",
  AUTHORITY_ADMIN: "AUTHORITY ADMIN",
  APP_ADMIN: "APP ADMIN",
  ACCOUNT_MANAGER: "ACCOUNT MANAGER",
};

// yet to be supported
// VLE_ADMIN: "VLE Admin", VLE admin added for announcement view rights
// CCPM_ADMIN: "CCPM Admin", CCPM admin added for manage user rights
// AUTHORITY_ADMIN: "Authority Admin", Authority admin added for manage user rights
// ACCOUNT_MANAGER: "Account Manager",
// APP_ADMIN: "App Admin"

// removed
// VLE_USER and CCPM_USER
